import Container from "react-bootstrap/Container";
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import { Button,Card, Row } from "react-bootstrap";
import Parser from "html-react-parser";

function PricingDetailsMain(props) {
  const { data } = props;

  return (
    <div id="pricing" style={{ paddingTop: "20px" }}>
      <h1 className="widget-title">{data.title}</h1>
      <Container>
        {/* <PricingDescription /> */}
        <br />
        <div className="pricing-day-cards">
          <Row>
            <Col md={12}>
              <PriceDetails
                id={2}
                single_supplement={data.single_supplement}
                insurance={data.insurance}
                title="Package"
                subtitle=""
                price={data.price}
                deposit={data.deposit}
                hideDeposit={false}
                deposit_and_payments={data.deposit_and_payments}
              >
                {Parser(data.paragraphs[0])}
              </PriceDetails>

      <p align="center">
        {" "}
        {data.show_button && (
          <Button
            variant="primary"
            target="_blank"
            href={data.list_button_link}
            style={{ backgroundColor: "#1b949d" }}
          >
            {data.list_button_name}
          </Button>
        )}
      </p>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default PricingDetailsMain;

function PriceDetails(props) {
  const [hideReadmore, setHideReadmore] = useState(true);

  function toggleReadMore() {
    setHideReadmore(false);
    var elements = findChild(`Pricing-${props.id}`, "collapse");

    if (elements) {
      elements.classList.remove("collapse");
      elements.classList.add("collapse.show");
    }
  }

  function findChild(idOfElement, idOfChild) {
    let element = document.getElementById(idOfElement);
    return element.querySelector("[class=" + idOfChild + "]");
  }

  return (
    <Card>
      <Card.Body id={`Pricing-${props.id}`} aria-controls="collapse">
        <Card.Title>
          {props.title} <span style={{ float: "right" }}>{props.price}</span>
        </Card.Title>
        <Card.Text>
          {!props.hideDeposit && (
            <small style={{ float: "right" }}>Deposit: {props.deposit}</small>
          )}

          <br />
          <br />
          <h5>{props.subtitle}</h5>
          {props.children}
        </Card.Text>
        {/* <p
          className="readmore-link"
          onClick={toggleReadMore}
          style={{ display: hideReadmore ? "block" : "none" }}
        >
          Read More
        </p> */}
        <br />
        <br />
        <Row>
        <Col>
            <h1 className="card-title" style={{ fontSize: "11pt" }}>
              Single Supplement
            </h1>
            <small style={{ float: "left" }}>{props.single_supplement}</small>
          </Col>
          <Col>
            <h1 className="card-title" style={{ fontSize: "11pt" }}>
              Deposit and Payments
            </h1>
            <small style={{ float: "left" }}>
              {Parser(props.deposit_and_payments)}
            </small>
          </Col>
          
          <Col>
            <h1 className="card-title" style={{ fontSize: "11pt" }}>
              Insurance Requirement
            </h1>
            <small style={{ float: "left" }}>{props.insurance}</small>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
